import { isAndroid, isIos } from './general';

export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/amplio-deaf-music-player/id6757407111';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.ampliomusic.app';

/**
 * If on a mobile device, redirect to the appropriate app store and return true.
 * Returns false if not on mobile (caller should show the download popup instead).
 */
export const redirectToMobileAppStore = (): boolean => {
  if (isIos()) {
    window.open(IOS_APP_STORE_URL, '_blank');
    return true;
  } else if (isAndroid()) {
    window.open(GOOGLE_PLAY_URL, '_blank');
    return true;
  }
  return false;
};
